import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

export const SERVICES = [
    "Hotel Operations",
    "Serviced Apartment Operations",
    "Restaurant, Bar & Pub Operations",
    "Guest Experience Improvement",
    "Revenue Improvement",
    "SOP Development",
    "Staff Training",
    "Operational Audits",
    "Property Management Support",
    "Quality Assurance Reviews",
    "Hospitality Consultancy for Independent Owners and Investors",
];
